// source: chat/chat.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js');
goog.object.extend(proto, chatcontext_chatcontext_pb);
var artifact_artifact_pb = require('../artifact/artifact_pb.js');
goog.object.extend(proto, artifact_artifact_pb);
var tichatapi_agent_pb = require('../tichatapi/agent_pb.js');
goog.object.extend(proto, tichatapi_agent_pb);
var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
var playbook_playbook_pb = require('../playbook/playbook_pb.js');
goog.object.extend(proto, playbook_playbook_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.chat.AgentMessageMetadata', null, global);
goog.exportSymbol('proto.chat.AnswerReactionType', null, global);
goog.exportSymbol('proto.chat.AppCopilotReferringContextMetadata', null, global);
goog.exportSymbol('proto.chat.AppendAgentExchangeRequest', null, global);
goog.exportSymbol('proto.chat.AppendAgentExchangeResponse', null, global);
goog.exportSymbol('proto.chat.Chat', null, global);
goog.exportSymbol('proto.chat.ChatContextUpdatedLogEntry', null, global);
goog.exportSymbol('proto.chat.ChatMessage', null, global);
goog.exportSymbol('proto.chat.ChatMessage.MetadataCase', null, global);
goog.exportSymbol('proto.chat.ChatMessageType', null, global);
goog.exportSymbol('proto.chat.ChatPreview', null, global);
goog.exportSymbol('proto.chat.ChatSearchResultType', null, global);
goog.exportSymbol('proto.chat.ChatWithPlaybookRuns', null, global);
goog.exportSymbol('proto.chat.Conversation', null, global);
goog.exportSymbol('proto.chat.CreateAppCopilotChatRequest', null, global);
goog.exportSymbol('proto.chat.CreateAppCopilotChatResponse', null, global);
goog.exportSymbol('proto.chat.CreateChatRequest', null, global);
goog.exportSymbol('proto.chat.DeleteChatRequest', null, global);
goog.exportSymbol('proto.chat.DeleteReactionToAnswerRequest', null, global);
goog.exportSymbol('proto.chat.GetChatMessagesSinceRequest', null, global);
goog.exportSymbol('proto.chat.GetChatMessagesSinceResponse', null, global);
goog.exportSymbol('proto.chat.GetChatRequest', null, global);
goog.exportSymbol('proto.chat.GetChatResponse', null, global);
goog.exportSymbol('proto.chat.GetIntermediateStatusRequest', null, global);
goog.exportSymbol('proto.chat.GetIntermediateStatusResponse', null, global);
goog.exportSymbol('proto.chat.GetIntermediateStatusResponse.ProgressCase', null, global);
goog.exportSymbol('proto.chat.GetStreamingMessagesRequest', null, global);
goog.exportSymbol('proto.chat.GetStreamingMessagesResponse', null, global);
goog.exportSymbol('proto.chat.ListAppCopilotChatsRequest', null, global);
goog.exportSymbol('proto.chat.ListAppCopilotChatsResponse', null, global);
goog.exportSymbol('proto.chat.ListChatsForPlaybookRequest', null, global);
goog.exportSymbol('proto.chat.ListChatsForPlaybookResponse', null, global);
goog.exportSymbol('proto.chat.ListChatsResponse', null, global);
goog.exportSymbol('proto.chat.ListTimelineEventsRequest', null, global);
goog.exportSymbol('proto.chat.ListTimelineEventsResponse', null, global);
goog.exportSymbol('proto.chat.Owner', null, global);
goog.exportSymbol('proto.chat.PlaybookRunInfo', null, global);
goog.exportSymbol('proto.chat.ReactToAnswerRequest', null, global);
goog.exportSymbol('proto.chat.Reaction', null, global);
goog.exportSymbol('proto.chat.Reactions', null, global);
goog.exportSymbol('proto.chat.ReferringContext', null, global);
goog.exportSymbol('proto.chat.SearchChatRequest', null, global);
goog.exportSymbol('proto.chat.SearchChatResponse', null, global);
goog.exportSymbol('proto.chat.SearchChatResult', null, global);
goog.exportSymbol('proto.chat.SendChatMessageRequest', null, global);
goog.exportSymbol('proto.chat.SendChatMessageResponse', null, global);
goog.exportSymbol('proto.chat.StopChatRequest', null, global);
goog.exportSymbol('proto.chat.StreamingMessageType', null, global);
goog.exportSymbol('proto.chat.TimelineEvent', null, global);
goog.exportSymbol('proto.chat.UpdateChatRequest', null, global);
goog.exportSymbol('proto.chat.UserMessageMetadata', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.AppendAgentExchangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.AppendAgentExchangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.AppendAgentExchangeRequest.displayName = 'proto.chat.AppendAgentExchangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.AppendAgentExchangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.AppendAgentExchangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.AppendAgentExchangeResponse.displayName = 'proto.chat.AppendAgentExchangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ChatPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ChatPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ChatPreview.displayName = 'proto.chat.ChatPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.Chat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.Chat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.Chat.displayName = 'proto.chat.Chat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.Conversation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.Conversation.repeatedFields_, null);
};
goog.inherits(proto.chat.Conversation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.Conversation.displayName = 'proto.chat.Conversation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ChatContextUpdatedLogEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ChatContextUpdatedLogEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ChatContextUpdatedLogEntry.displayName = 'proto.chat.ChatContextUpdatedLogEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ChatMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.chat.ChatMessage.oneofGroups_);
};
goog.inherits(proto.chat.ChatMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ChatMessage.displayName = 'proto.chat.ChatMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.AgentMessageMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.AgentMessageMetadata.repeatedFields_, null);
};
goog.inherits(proto.chat.AgentMessageMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.AgentMessageMetadata.displayName = 'proto.chat.AgentMessageMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.UserMessageMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.UserMessageMetadata.repeatedFields_, null);
};
goog.inherits(proto.chat.UserMessageMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.UserMessageMetadata.displayName = 'proto.chat.UserMessageMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.Reactions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.Reactions.repeatedFields_, null);
};
goog.inherits(proto.chat.Reactions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.Reactions.displayName = 'proto.chat.Reactions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.Reaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.Reaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.Reaction.displayName = 'proto.chat.Reaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.Owner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.Owner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.Owner.displayName = 'proto.chat.Owner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.CreateChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.CreateChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.CreateChatRequest.displayName = 'proto.chat.CreateChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ReferringContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ReferringContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ReferringContext.displayName = 'proto.chat.ReferringContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.AppCopilotReferringContextMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.AppCopilotReferringContextMetadata.repeatedFields_, null);
};
goog.inherits(proto.chat.AppCopilotReferringContextMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.AppCopilotReferringContextMetadata.displayName = 'proto.chat.AppCopilotReferringContextMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListAppCopilotChatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ListAppCopilotChatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListAppCopilotChatsRequest.displayName = 'proto.chat.ListAppCopilotChatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListAppCopilotChatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.ListAppCopilotChatsResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.ListAppCopilotChatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListAppCopilotChatsResponse.displayName = 'proto.chat.ListAppCopilotChatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.CreateAppCopilotChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.CreateAppCopilotChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.CreateAppCopilotChatRequest.displayName = 'proto.chat.CreateAppCopilotChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.CreateAppCopilotChatResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.CreateAppCopilotChatResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.CreateAppCopilotChatResponse.displayName = 'proto.chat.CreateAppCopilotChatResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.GetChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetChatRequest.displayName = 'proto.chat.GetChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.DeleteChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.DeleteChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.DeleteChatRequest.displayName = 'proto.chat.DeleteChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.StopChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.StopChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.StopChatRequest.displayName = 'proto.chat.StopChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetChatResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.GetChatResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetChatResponse.displayName = 'proto.chat.GetChatResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListChatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.ListChatsResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.ListChatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListChatsResponse.displayName = 'proto.chat.ListChatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.UpdateChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.UpdateChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.UpdateChatRequest.displayName = 'proto.chat.UpdateChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.SendChatMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.SendChatMessageRequest.repeatedFields_, null);
};
goog.inherits(proto.chat.SendChatMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.SendChatMessageRequest.displayName = 'proto.chat.SendChatMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.SendChatMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.SendChatMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.SendChatMessageResponse.displayName = 'proto.chat.SendChatMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.TimelineEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.TimelineEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.TimelineEvent.displayName = 'proto.chat.TimelineEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListTimelineEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ListTimelineEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListTimelineEventsRequest.displayName = 'proto.chat.ListTimelineEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListTimelineEventsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.ListTimelineEventsResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.ListTimelineEventsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListTimelineEventsResponse.displayName = 'proto.chat.ListTimelineEventsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetChatMessagesSinceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.GetChatMessagesSinceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetChatMessagesSinceRequest.displayName = 'proto.chat.GetChatMessagesSinceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetChatMessagesSinceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.GetChatMessagesSinceResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.GetChatMessagesSinceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetChatMessagesSinceResponse.displayName = 'proto.chat.GetChatMessagesSinceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ReactToAnswerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ReactToAnswerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ReactToAnswerRequest.displayName = 'proto.chat.ReactToAnswerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.DeleteReactionToAnswerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.DeleteReactionToAnswerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.DeleteReactionToAnswerRequest.displayName = 'proto.chat.DeleteReactionToAnswerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetIntermediateStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.GetIntermediateStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetIntermediateStatusRequest.displayName = 'proto.chat.GetIntermediateStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetIntermediateStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.GetIntermediateStatusResponse.repeatedFields_, proto.chat.GetIntermediateStatusResponse.oneofGroups_);
};
goog.inherits(proto.chat.GetIntermediateStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetIntermediateStatusResponse.displayName = 'proto.chat.GetIntermediateStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetStreamingMessagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.GetStreamingMessagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetStreamingMessagesRequest.displayName = 'proto.chat.GetStreamingMessagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.GetStreamingMessagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.GetStreamingMessagesResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.GetStreamingMessagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.GetStreamingMessagesResponse.displayName = 'proto.chat.GetStreamingMessagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.SearchChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.SearchChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.SearchChatRequest.displayName = 'proto.chat.SearchChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.SearchChatResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.SearchChatResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.SearchChatResult.displayName = 'proto.chat.SearchChatResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.SearchChatResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.SearchChatResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.SearchChatResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.SearchChatResponse.displayName = 'proto.chat.SearchChatResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListChatsForPlaybookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.ListChatsForPlaybookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListChatsForPlaybookRequest.displayName = 'proto.chat.ListChatsForPlaybookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.PlaybookRunInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.chat.PlaybookRunInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.PlaybookRunInfo.displayName = 'proto.chat.PlaybookRunInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ChatWithPlaybookRuns = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.ChatWithPlaybookRuns.repeatedFields_, null);
};
goog.inherits(proto.chat.ChatWithPlaybookRuns, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ChatWithPlaybookRuns.displayName = 'proto.chat.ChatWithPlaybookRuns';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.chat.ListChatsForPlaybookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.chat.ListChatsForPlaybookResponse.repeatedFields_, null);
};
goog.inherits(proto.chat.ListChatsForPlaybookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.chat.ListChatsForPlaybookResponse.displayName = 'proto.chat.ListChatsForPlaybookResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.AppendAgentExchangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.AppendAgentExchangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.AppendAgentExchangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppendAgentExchangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    question: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.AppendAgentExchangeRequest}
 */
proto.chat.AppendAgentExchangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.AppendAgentExchangeRequest;
  return proto.chat.AppendAgentExchangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.AppendAgentExchangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.AppendAgentExchangeRequest}
 */
proto.chat.AppendAgentExchangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.AppendAgentExchangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.AppendAgentExchangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.AppendAgentExchangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppendAgentExchangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.chat.AppendAgentExchangeRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AppendAgentExchangeRequest} returns this
 */
proto.chat.AppendAgentExchangeRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chat_id = 2;
 * @return {string}
 */
proto.chat.AppendAgentExchangeRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AppendAgentExchangeRequest} returns this
 */
proto.chat.AppendAgentExchangeRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string question = 3;
 * @return {string}
 */
proto.chat.AppendAgentExchangeRequest.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AppendAgentExchangeRequest} returns this
 */
proto.chat.AppendAgentExchangeRequest.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.AppendAgentExchangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.AppendAgentExchangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.AppendAgentExchangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppendAgentExchangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.AppendAgentExchangeResponse}
 */
proto.chat.AppendAgentExchangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.AppendAgentExchangeResponse;
  return proto.chat.AppendAgentExchangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.AppendAgentExchangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.AppendAgentExchangeResponse}
 */
proto.chat.AppendAgentExchangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.AppendAgentExchangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.AppendAgentExchangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.AppendAgentExchangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppendAgentExchangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.chat.AppendAgentExchangeResponse.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AppendAgentExchangeResponse} returns this
 */
proto.chat.AppendAgentExchangeResponse.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ChatPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ChatPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ChatPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    owner: (f = msg.getOwner()) && proto.chat.Owner.toObject(includeInstance, f),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isAgentChat: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ChatPreview}
 */
proto.chat.ChatPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ChatPreview;
  return proto.chat.ChatPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ChatPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ChatPreview}
 */
proto.chat.ChatPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = new proto.chat.Owner;
      reader.readMessage(value,proto.chat.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAgentChat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ChatPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ChatPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ChatPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.chat.Owner.serializeBinaryToWriter
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsAgentChat();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.ChatPreview.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.chat.ChatPreview.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.chat.ChatPreview.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 updated_at = 4;
 * @return {number}
 */
proto.chat.ChatPreview.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Owner owner = 5;
 * @return {?proto.chat.Owner}
 */
proto.chat.ChatPreview.prototype.getOwner = function() {
  return /** @type{?proto.chat.Owner} */ (
    jspb.Message.getWrapperField(this, proto.chat.Owner, 5));
};


/**
 * @param {?proto.chat.Owner|undefined} value
 * @return {!proto.chat.ChatPreview} returns this
*/
proto.chat.ChatPreview.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.ChatPreview.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_private = 6;
 * @return {boolean}
 */
proto.chat.ChatPreview.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_agent_chat = 7;
 * @return {boolean}
 */
proto.chat.ChatPreview.prototype.getIsAgentChat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.ChatPreview} returns this
 */
proto.chat.ChatPreview.prototype.setIsAgentChat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.Chat.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.Chat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.Chat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Chat.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    chatContext: (f = msg.getChatContext()) && chatcontext_chatcontext_pb.ChatContext.toObject(includeInstance, f),
    conversation: (f = msg.getConversation()) && proto.chat.Conversation.toObject(includeInstance, f),
    owner: (f = msg.getOwner()) && proto.chat.Owner.toObject(includeInstance, f),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    model: jspb.Message.getFieldWithDefault(msg, 10, ""),
    isAgentChat: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    leadPrompt: jspb.Message.getFieldWithDefault(msg, 12, ""),
    initiatePrompt: jspb.Message.getFieldWithDefault(msg, 13, ""),
    playbookInputs: (f = msg.getPlaybookInputs()) && playbook_playbook_pb.PlaybookInputs.toObject(includeInstance, f),
    initiatedBy: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.Chat}
 */
proto.chat.Chat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.Chat;
  return proto.chat.Chat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.Chat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.Chat}
 */
proto.chat.Chat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = new chatcontext_chatcontext_pb.ChatContext;
      reader.readMessage(value,chatcontext_chatcontext_pb.ChatContext.deserializeBinaryFromReader);
      msg.setChatContext(value);
      break;
    case 7:
      var value = new proto.chat.Conversation;
      reader.readMessage(value,proto.chat.Conversation.deserializeBinaryFromReader);
      msg.setConversation(value);
      break;
    case 8:
      var value = new proto.chat.Owner;
      reader.readMessage(value,proto.chat.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAgentChat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadPrompt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setInitiatePrompt(value);
      break;
    case 14:
      var value = new playbook_playbook_pb.PlaybookInputs;
      reader.readMessage(value,playbook_playbook_pb.PlaybookInputs.deserializeBinaryFromReader);
      msg.setPlaybookInputs(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setInitiatedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.Chat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.Chat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.Chat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Chat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getChatContext();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      chatcontext_chatcontext_pb.ChatContext.serializeBinaryToWriter
    );
  }
  f = message.getConversation();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.chat.Conversation.serializeBinaryToWriter
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.chat.Owner.serializeBinaryToWriter
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIsAgentChat();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getLeadPrompt();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInitiatePrompt();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPlaybookInputs();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      playbook_playbook_pb.PlaybookInputs.serializeBinaryToWriter
    );
  }
  f = message.getInitiatedBy();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.Chat.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.chat.Chat.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.chat.Chat.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.chat.Chat.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.chat.Chat.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional chatcontext.ChatContext chat_context = 6;
 * @return {?proto.chatcontext.ChatContext}
 */
proto.chat.Chat.prototype.getChatContext = function() {
  return /** @type{?proto.chatcontext.ChatContext} */ (
    jspb.Message.getWrapperField(this, chatcontext_chatcontext_pb.ChatContext, 6));
};


/**
 * @param {?proto.chatcontext.ChatContext|undefined} value
 * @return {!proto.chat.Chat} returns this
*/
proto.chat.Chat.prototype.setChatContext = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.clearChatContext = function() {
  return this.setChatContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.Chat.prototype.hasChatContext = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Conversation conversation = 7;
 * @return {?proto.chat.Conversation}
 */
proto.chat.Chat.prototype.getConversation = function() {
  return /** @type{?proto.chat.Conversation} */ (
    jspb.Message.getWrapperField(this, proto.chat.Conversation, 7));
};


/**
 * @param {?proto.chat.Conversation|undefined} value
 * @return {!proto.chat.Chat} returns this
*/
proto.chat.Chat.prototype.setConversation = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.clearConversation = function() {
  return this.setConversation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.Chat.prototype.hasConversation = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Owner owner = 8;
 * @return {?proto.chat.Owner}
 */
proto.chat.Chat.prototype.getOwner = function() {
  return /** @type{?proto.chat.Owner} */ (
    jspb.Message.getWrapperField(this, proto.chat.Owner, 8));
};


/**
 * @param {?proto.chat.Owner|undefined} value
 * @return {!proto.chat.Chat} returns this
*/
proto.chat.Chat.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.Chat.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool is_private = 9;
 * @return {boolean}
 */
proto.chat.Chat.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string model = 10;
 * @return {string}
 */
proto.chat.Chat.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool is_agent_chat = 11;
 * @return {boolean}
 */
proto.chat.Chat.prototype.getIsAgentChat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setIsAgentChat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string lead_prompt = 12;
 * @return {string}
 */
proto.chat.Chat.prototype.getLeadPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setLeadPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string initiate_prompt = 13;
 * @return {string}
 */
proto.chat.Chat.prototype.getInitiatePrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setInitiatePrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional playbook.PlaybookInputs playbook_inputs = 14;
 * @return {?proto.playbook.PlaybookInputs}
 */
proto.chat.Chat.prototype.getPlaybookInputs = function() {
  return /** @type{?proto.playbook.PlaybookInputs} */ (
    jspb.Message.getWrapperField(this, playbook_playbook_pb.PlaybookInputs, 14));
};


/**
 * @param {?proto.playbook.PlaybookInputs|undefined} value
 * @return {!proto.chat.Chat} returns this
*/
proto.chat.Chat.prototype.setPlaybookInputs = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.clearPlaybookInputs = function() {
  return this.setPlaybookInputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.Chat.prototype.hasPlaybookInputs = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string initiated_by = 16;
 * @return {string}
 */
proto.chat.Chat.prototype.getInitiatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Chat} returns this
 */
proto.chat.Chat.prototype.setInitiatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.Conversation.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.Conversation.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.Conversation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.Conversation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Conversation.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.chat.ChatMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.Conversation}
 */
proto.chat.Conversation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.Conversation;
  return proto.chat.Conversation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.Conversation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.Conversation}
 */
proto.chat.Conversation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatMessage;
      reader.readMessage(value,proto.chat.ChatMessage.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.Conversation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.Conversation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.Conversation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Conversation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatMessage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChatMessage messages = 1;
 * @return {!Array<!proto.chat.ChatMessage>}
 */
proto.chat.Conversation.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.chat.ChatMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatMessage, 1));
};


/**
 * @param {!Array<!proto.chat.ChatMessage>} value
 * @return {!proto.chat.Conversation} returns this
*/
proto.chat.Conversation.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatMessage}
 */
proto.chat.Conversation.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.Conversation} returns this
 */
proto.chat.Conversation.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ChatContextUpdatedLogEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ChatContextUpdatedLogEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatContextUpdatedLogEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    owner: (f = msg.getOwner()) && proto.chat.Owner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ChatContextUpdatedLogEntry}
 */
proto.chat.ChatContextUpdatedLogEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ChatContextUpdatedLogEntry;
  return proto.chat.ChatContextUpdatedLogEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ChatContextUpdatedLogEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ChatContextUpdatedLogEntry}
 */
proto.chat.ChatContextUpdatedLogEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = new proto.chat.Owner;
      reader.readMessage(value,proto.chat.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ChatContextUpdatedLogEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ChatContextUpdatedLogEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatContextUpdatedLogEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.chat.Owner.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 created_at = 1;
 * @return {number}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatContextUpdatedLogEntry} returns this
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatContextUpdatedLogEntry} returns this
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Owner owner = 3;
 * @return {?proto.chat.Owner}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.getOwner = function() {
  return /** @type{?proto.chat.Owner} */ (
    jspb.Message.getWrapperField(this, proto.chat.Owner, 3));
};


/**
 * @param {?proto.chat.Owner|undefined} value
 * @return {!proto.chat.ChatContextUpdatedLogEntry} returns this
*/
proto.chat.ChatContextUpdatedLogEntry.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.ChatContextUpdatedLogEntry} returns this
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.ChatContextUpdatedLogEntry.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.chat.ChatMessage.oneofGroups_ = [[6,7]];

/**
 * @enum {number}
 */
proto.chat.ChatMessage.MetadataCase = {
  METADATA_NOT_SET: 0,
  AGENT_MESSAGE_METADATA: 6,
  USER_MESSAGE_METADATA: 7
};

/**
 * @return {proto.chat.ChatMessage.MetadataCase}
 */
proto.chat.ChatMessage.prototype.getMetadataCase = function() {
  return /** @type {proto.chat.ChatMessage.MetadataCase} */(jspb.Message.computeOneofCase(this, proto.chat.ChatMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ChatMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ChatMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ChatMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    agentMessageMetadata: (f = msg.getAgentMessageMetadata()) && proto.chat.AgentMessageMetadata.toObject(includeInstance, f),
    userMessageMetadata: (f = msg.getUserMessageMetadata()) && proto.chat.UserMessageMetadata.toObject(includeInstance, f),
    chatContextVersion: jspb.Message.getFieldWithDefault(msg, 8, 0),
    playbookRunId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ChatMessage}
 */
proto.chat.ChatMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ChatMessage;
  return proto.chat.ChatMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ChatMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ChatMessage}
 */
proto.chat.ChatMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = /** @type {!proto.chat.ChatMessageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new proto.chat.AgentMessageMetadata;
      reader.readMessage(value,proto.chat.AgentMessageMetadata.deserializeBinaryFromReader);
      msg.setAgentMessageMetadata(value);
      break;
    case 7:
      var value = new proto.chat.UserMessageMetadata;
      reader.readMessage(value,proto.chat.UserMessageMetadata.deserializeBinaryFromReader);
      msg.setUserMessageMetadata(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChatContextVersion(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookRunId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ChatMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ChatMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ChatMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAgentMessageMetadata();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.chat.AgentMessageMetadata.serializeBinaryToWriter
    );
  }
  f = message.getUserMessageMetadata();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.chat.UserMessageMetadata.serializeBinaryToWriter
    );
  }
  f = message.getChatContextVersion();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPlaybookRunId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.ChatMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.chat.ChatMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.chat.ChatMessage.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 updated_at = 4;
 * @return {number}
 */
proto.chat.ChatMessage.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ChatMessageType type = 5;
 * @return {!proto.chat.ChatMessageType}
 */
proto.chat.ChatMessage.prototype.getType = function() {
  return /** @type {!proto.chat.ChatMessageType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.chat.ChatMessageType} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional AgentMessageMetadata agent_message_metadata = 6;
 * @return {?proto.chat.AgentMessageMetadata}
 */
proto.chat.ChatMessage.prototype.getAgentMessageMetadata = function() {
  return /** @type{?proto.chat.AgentMessageMetadata} */ (
    jspb.Message.getWrapperField(this, proto.chat.AgentMessageMetadata, 6));
};


/**
 * @param {?proto.chat.AgentMessageMetadata|undefined} value
 * @return {!proto.chat.ChatMessage} returns this
*/
proto.chat.ChatMessage.prototype.setAgentMessageMetadata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.chat.ChatMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.clearAgentMessageMetadata = function() {
  return this.setAgentMessageMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.ChatMessage.prototype.hasAgentMessageMetadata = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional UserMessageMetadata user_message_metadata = 7;
 * @return {?proto.chat.UserMessageMetadata}
 */
proto.chat.ChatMessage.prototype.getUserMessageMetadata = function() {
  return /** @type{?proto.chat.UserMessageMetadata} */ (
    jspb.Message.getWrapperField(this, proto.chat.UserMessageMetadata, 7));
};


/**
 * @param {?proto.chat.UserMessageMetadata|undefined} value
 * @return {!proto.chat.ChatMessage} returns this
*/
proto.chat.ChatMessage.prototype.setUserMessageMetadata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.chat.ChatMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.clearUserMessageMetadata = function() {
  return this.setUserMessageMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.ChatMessage.prototype.hasUserMessageMetadata = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 chat_context_version = 8;
 * @return {number}
 */
proto.chat.ChatMessage.prototype.getChatContextVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setChatContextVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string playbook_run_id = 9;
 * @return {string}
 */
proto.chat.ChatMessage.prototype.getPlaybookRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatMessage} returns this
 */
proto.chat.ChatMessage.prototype.setPlaybookRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.AgentMessageMetadata.repeatedFields_ = [3,7,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.AgentMessageMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.AgentMessageMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.AgentMessageMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AgentMessageMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    userMessageId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reactions: (f = msg.getReactions()) && proto.chat.Reactions.toObject(includeInstance, f),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    chatcontext_chatcontext_pb.ChatCitation.toObject, includeInstance),
    model: jspb.Message.getFieldWithDefault(msg, 4, ""),
    confirmationDataType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    confirmationText: (f = msg.getConfirmationText()) && tichatapi_agent_pb.ConfirmationText.toObject(includeInstance, f),
    artifactsList: jspb.Message.toObjectList(msg.getArtifactsList(),
    artifact_artifact_pb.Artifact.toObject, includeInstance),
    followUpPrompt: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isStreamingMessage: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    fileDownloadsList: jspb.Message.toObjectList(msg.getFileDownloadsList(),
    common_model_pb.FileUpload.toObject, includeInstance),
    isDebugMessage: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    streamingMessageType: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.AgentMessageMetadata}
 */
proto.chat.AgentMessageMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.AgentMessageMetadata;
  return proto.chat.AgentMessageMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.AgentMessageMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.AgentMessageMetadata}
 */
proto.chat.AgentMessageMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserMessageId(value);
      break;
    case 2:
      var value = new proto.chat.Reactions;
      reader.readMessage(value,proto.chat.Reactions.deserializeBinaryFromReader);
      msg.setReactions(value);
      break;
    case 3:
      var value = new chatcontext_chatcontext_pb.ChatCitation;
      reader.readMessage(value,chatcontext_chatcontext_pb.ChatCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {!proto.tichatapi.ConfirmationDataType} */ (reader.readEnum());
      msg.setConfirmationDataType(value);
      break;
    case 6:
      var value = new tichatapi_agent_pb.ConfirmationText;
      reader.readMessage(value,tichatapi_agent_pb.ConfirmationText.deserializeBinaryFromReader);
      msg.setConfirmationText(value);
      break;
    case 7:
      var value = new artifact_artifact_pb.Artifact;
      reader.readMessage(value,artifact_artifact_pb.Artifact.deserializeBinaryFromReader);
      msg.addArtifacts(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowUpPrompt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsStreamingMessage(value);
      break;
    case 10:
      var value = new common_model_pb.FileUpload;
      reader.readMessage(value,common_model_pb.FileUpload.deserializeBinaryFromReader);
      msg.addFileDownloads(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDebugMessage(value);
      break;
    case 12:
      var value = /** @type {!proto.chat.StreamingMessageType} */ (reader.readEnum());
      msg.setStreamingMessageType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.AgentMessageMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.AgentMessageMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.AgentMessageMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AgentMessageMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserMessageId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReactions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.chat.Reactions.serializeBinaryToWriter
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      chatcontext_chatcontext_pb.ChatCitation.serializeBinaryToWriter
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConfirmationDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getConfirmationText();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      tichatapi_agent_pb.ConfirmationText.serializeBinaryToWriter
    );
  }
  f = message.getArtifactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      artifact_artifact_pb.Artifact.serializeBinaryToWriter
    );
  }
  f = message.getFollowUpPrompt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsStreamingMessage();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getFileDownloadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      common_model_pb.FileUpload.serializeBinaryToWriter
    );
  }
  f = message.getIsDebugMessage();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getStreamingMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional string user_message_id = 1;
 * @return {string}
 */
proto.chat.AgentMessageMetadata.prototype.getUserMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setUserMessageId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Reactions reactions = 2;
 * @return {?proto.chat.Reactions}
 */
proto.chat.AgentMessageMetadata.prototype.getReactions = function() {
  return /** @type{?proto.chat.Reactions} */ (
    jspb.Message.getWrapperField(this, proto.chat.Reactions, 2));
};


/**
 * @param {?proto.chat.Reactions|undefined} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
*/
proto.chat.AgentMessageMetadata.prototype.setReactions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.clearReactions = function() {
  return this.setReactions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.AgentMessageMetadata.prototype.hasReactions = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated chatcontext.ChatCitation citations = 3;
 * @return {!Array<!proto.chatcontext.ChatCitation>}
 */
proto.chat.AgentMessageMetadata.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.chatcontext.ChatCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, chatcontext_chatcontext_pb.ChatCitation, 3));
};


/**
 * @param {!Array<!proto.chatcontext.ChatCitation>} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
*/
proto.chat.AgentMessageMetadata.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.chatcontext.ChatCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chatcontext.ChatCitation}
 */
proto.chat.AgentMessageMetadata.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.chatcontext.ChatCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.chat.AgentMessageMetadata.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional tichatapi.ConfirmationDataType confirmation_data_type = 5;
 * @return {!proto.tichatapi.ConfirmationDataType}
 */
proto.chat.AgentMessageMetadata.prototype.getConfirmationDataType = function() {
  return /** @type {!proto.tichatapi.ConfirmationDataType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tichatapi.ConfirmationDataType} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setConfirmationDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional tichatapi.ConfirmationText confirmation_text = 6;
 * @return {?proto.tichatapi.ConfirmationText}
 */
proto.chat.AgentMessageMetadata.prototype.getConfirmationText = function() {
  return /** @type{?proto.tichatapi.ConfirmationText} */ (
    jspb.Message.getWrapperField(this, tichatapi_agent_pb.ConfirmationText, 6));
};


/**
 * @param {?proto.tichatapi.ConfirmationText|undefined} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
*/
proto.chat.AgentMessageMetadata.prototype.setConfirmationText = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.clearConfirmationText = function() {
  return this.setConfirmationText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.AgentMessageMetadata.prototype.hasConfirmationText = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated artifact.Artifact artifacts = 7;
 * @return {!Array<!proto.artifact.Artifact>}
 */
proto.chat.AgentMessageMetadata.prototype.getArtifactsList = function() {
  return /** @type{!Array<!proto.artifact.Artifact>} */ (
    jspb.Message.getRepeatedWrapperField(this, artifact_artifact_pb.Artifact, 7));
};


/**
 * @param {!Array<!proto.artifact.Artifact>} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
*/
proto.chat.AgentMessageMetadata.prototype.setArtifactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.artifact.Artifact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Artifact}
 */
proto.chat.AgentMessageMetadata.prototype.addArtifacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.artifact.Artifact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.clearArtifactsList = function() {
  return this.setArtifactsList([]);
};


/**
 * optional string follow_up_prompt = 8;
 * @return {string}
 */
proto.chat.AgentMessageMetadata.prototype.getFollowUpPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setFollowUpPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_streaming_message = 9;
 * @return {boolean}
 */
proto.chat.AgentMessageMetadata.prototype.getIsStreamingMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setIsStreamingMessage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * repeated common.FileUpload file_downloads = 10;
 * @return {!Array<!proto.common.FileUpload>}
 */
proto.chat.AgentMessageMetadata.prototype.getFileDownloadsList = function() {
  return /** @type{!Array<!proto.common.FileUpload>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUpload, 10));
};


/**
 * @param {!Array<!proto.common.FileUpload>} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
*/
proto.chat.AgentMessageMetadata.prototype.setFileDownloadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.common.FileUpload=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUpload}
 */
proto.chat.AgentMessageMetadata.prototype.addFileDownloads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.common.FileUpload, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.clearFileDownloadsList = function() {
  return this.setFileDownloadsList([]);
};


/**
 * optional bool is_debug_message = 11;
 * @return {boolean}
 */
proto.chat.AgentMessageMetadata.prototype.getIsDebugMessage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setIsDebugMessage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional StreamingMessageType streaming_message_type = 12;
 * @return {!proto.chat.StreamingMessageType}
 */
proto.chat.AgentMessageMetadata.prototype.getStreamingMessageType = function() {
  return /** @type {!proto.chat.StreamingMessageType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.chat.StreamingMessageType} value
 * @return {!proto.chat.AgentMessageMetadata} returns this
 */
proto.chat.AgentMessageMetadata.prototype.setStreamingMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.UserMessageMetadata.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.UserMessageMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.UserMessageMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.UserMessageMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.UserMessageMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    owner: (f = msg.getOwner()) && proto.chat.Owner.toObject(includeInstance, f),
    chatContextUpdated: (f = msg.getChatContextUpdated()) && proto.chat.ChatContextUpdatedLogEntry.toObject(includeInstance, f),
    clientMessageType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    fileUploadsList: jspb.Message.toObjectList(msg.getFileUploadsList(),
    common_model_pb.FileUpload.toObject, includeInstance),
    playbookPrompt: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isTrigger: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.UserMessageMetadata}
 */
proto.chat.UserMessageMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.UserMessageMetadata;
  return proto.chat.UserMessageMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.UserMessageMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.UserMessageMetadata}
 */
proto.chat.UserMessageMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.chat.Owner;
      reader.readMessage(value,proto.chat.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 4:
      var value = new proto.chat.ChatContextUpdatedLogEntry;
      reader.readMessage(value,proto.chat.ChatContextUpdatedLogEntry.deserializeBinaryFromReader);
      msg.setChatContextUpdated(value);
      break;
    case 5:
      var value = /** @type {!proto.tichatapi.ClientMessageType} */ (reader.readEnum());
      msg.setClientMessageType(value);
      break;
    case 6:
      var value = new common_model_pb.FileUpload;
      reader.readMessage(value,common_model_pb.FileUpload.deserializeBinaryFromReader);
      msg.addFileUploads(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookPrompt(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTrigger(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.UserMessageMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.UserMessageMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.UserMessageMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.UserMessageMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.chat.Owner.serializeBinaryToWriter
    );
  }
  f = message.getChatContextUpdated();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.chat.ChatContextUpdatedLogEntry.serializeBinaryToWriter
    );
  }
  f = message.getClientMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getFileUploadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      common_model_pb.FileUpload.serializeBinaryToWriter
    );
  }
  f = message.getPlaybookPrompt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsTrigger();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional Owner owner = 3;
 * @return {?proto.chat.Owner}
 */
proto.chat.UserMessageMetadata.prototype.getOwner = function() {
  return /** @type{?proto.chat.Owner} */ (
    jspb.Message.getWrapperField(this, proto.chat.Owner, 3));
};


/**
 * @param {?proto.chat.Owner|undefined} value
 * @return {!proto.chat.UserMessageMetadata} returns this
*/
proto.chat.UserMessageMetadata.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.UserMessageMetadata.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ChatContextUpdatedLogEntry chat_context_updated = 4;
 * @return {?proto.chat.ChatContextUpdatedLogEntry}
 */
proto.chat.UserMessageMetadata.prototype.getChatContextUpdated = function() {
  return /** @type{?proto.chat.ChatContextUpdatedLogEntry} */ (
    jspb.Message.getWrapperField(this, proto.chat.ChatContextUpdatedLogEntry, 4));
};


/**
 * @param {?proto.chat.ChatContextUpdatedLogEntry|undefined} value
 * @return {!proto.chat.UserMessageMetadata} returns this
*/
proto.chat.UserMessageMetadata.prototype.setChatContextUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.clearChatContextUpdated = function() {
  return this.setChatContextUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.UserMessageMetadata.prototype.hasChatContextUpdated = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional tichatapi.ClientMessageType client_message_type = 5;
 * @return {!proto.tichatapi.ClientMessageType}
 */
proto.chat.UserMessageMetadata.prototype.getClientMessageType = function() {
  return /** @type {!proto.tichatapi.ClientMessageType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tichatapi.ClientMessageType} value
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.setClientMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated common.FileUpload file_uploads = 6;
 * @return {!Array<!proto.common.FileUpload>}
 */
proto.chat.UserMessageMetadata.prototype.getFileUploadsList = function() {
  return /** @type{!Array<!proto.common.FileUpload>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUpload, 6));
};


/**
 * @param {!Array<!proto.common.FileUpload>} value
 * @return {!proto.chat.UserMessageMetadata} returns this
*/
proto.chat.UserMessageMetadata.prototype.setFileUploadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.common.FileUpload=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUpload}
 */
proto.chat.UserMessageMetadata.prototype.addFileUploads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.common.FileUpload, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.clearFileUploadsList = function() {
  return this.setFileUploadsList([]);
};


/**
 * optional string playbook_prompt = 7;
 * @return {string}
 */
proto.chat.UserMessageMetadata.prototype.getPlaybookPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.setPlaybookPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_trigger = 8;
 * @return {boolean}
 */
proto.chat.UserMessageMetadata.prototype.getIsTrigger = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.UserMessageMetadata} returns this
 */
proto.chat.UserMessageMetadata.prototype.setIsTrigger = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.Reactions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.Reactions.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.Reactions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.Reactions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Reactions.toObject = function(includeInstance, msg) {
  var f, obj = {
    reactionsList: jspb.Message.toObjectList(msg.getReactionsList(),
    proto.chat.Reaction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.Reactions}
 */
proto.chat.Reactions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.Reactions;
  return proto.chat.Reactions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.Reactions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.Reactions}
 */
proto.chat.Reactions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.Reaction;
      reader.readMessage(value,proto.chat.Reaction.deserializeBinaryFromReader);
      msg.addReactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.Reactions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.Reactions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.Reactions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Reactions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.Reaction.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Reaction reactions = 1;
 * @return {!Array<!proto.chat.Reaction>}
 */
proto.chat.Reactions.prototype.getReactionsList = function() {
  return /** @type{!Array<!proto.chat.Reaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.Reaction, 1));
};


/**
 * @param {!Array<!proto.chat.Reaction>} value
 * @return {!proto.chat.Reactions} returns this
*/
proto.chat.Reactions.prototype.setReactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.Reaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.Reaction}
 */
proto.chat.Reactions.prototype.addReactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.Reaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.Reactions} returns this
 */
proto.chat.Reactions.prototype.clearReactionsList = function() {
  return this.setReactionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.Reaction.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.Reaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.Reaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Reaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    reaction: jspb.Message.getFieldWithDefault(msg, 1, 0),
    owner: (f = msg.getOwner()) && proto.chat.Owner.toObject(includeInstance, f),
    feedback: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.Reaction}
 */
proto.chat.Reaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.Reaction;
  return proto.chat.Reaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.Reaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.Reaction}
 */
proto.chat.Reaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.chat.AnswerReactionType} */ (reader.readEnum());
      msg.setReaction(value);
      break;
    case 2:
      var value = new proto.chat.Owner;
      reader.readMessage(value,proto.chat.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeedback(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.Reaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.Reaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.Reaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Reaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReaction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.chat.Owner.serializeBinaryToWriter
    );
  }
  f = message.getFeedback();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional AnswerReactionType reaction = 1;
 * @return {!proto.chat.AnswerReactionType}
 */
proto.chat.Reaction.prototype.getReaction = function() {
  return /** @type {!proto.chat.AnswerReactionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.chat.AnswerReactionType} value
 * @return {!proto.chat.Reaction} returns this
 */
proto.chat.Reaction.prototype.setReaction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Owner owner = 2;
 * @return {?proto.chat.Owner}
 */
proto.chat.Reaction.prototype.getOwner = function() {
  return /** @type{?proto.chat.Owner} */ (
    jspb.Message.getWrapperField(this, proto.chat.Owner, 2));
};


/**
 * @param {?proto.chat.Owner|undefined} value
 * @return {!proto.chat.Reaction} returns this
*/
proto.chat.Reaction.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.Reaction} returns this
 */
proto.chat.Reaction.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.Reaction.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string feedback = 3;
 * @return {string}
 */
proto.chat.Reaction.prototype.getFeedback = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Reaction} returns this
 */
proto.chat.Reaction.prototype.setFeedback = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.Owner.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.Owner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.Owner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Owner.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.Owner}
 */
proto.chat.Owner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.Owner;
  return proto.chat.Owner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.Owner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.Owner}
 */
proto.chat.Owner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.Owner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.Owner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.Owner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.Owner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.Owner.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Owner} returns this
 */
proto.chat.Owner.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.chat.Owner.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Owner} returns this
 */
proto.chat.Owner.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.chat.Owner.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.Owner} returns this
 */
proto.chat.Owner.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.CreateChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.CreateChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.CreateChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatContext: (f = msg.getChatContext()) && chatcontext_chatcontext_pb.CreateChatContextRequest.toObject(includeInstance, f),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.CreateChatRequest}
 */
proto.chat.CreateChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.CreateChatRequest;
  return proto.chat.CreateChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.CreateChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.CreateChatRequest}
 */
proto.chat.CreateChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new chatcontext_chatcontext_pb.CreateChatContextRequest;
      reader.readMessage(value,chatcontext_chatcontext_pb.CreateChatContextRequest.deserializeBinaryFromReader);
      msg.setChatContext(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.CreateChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.CreateChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.CreateChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatContext();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      chatcontext_chatcontext_pb.CreateChatContextRequest.serializeBinaryToWriter
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.chat.CreateChatRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.CreateChatRequest} returns this
 */
proto.chat.CreateChatRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional chatcontext.CreateChatContextRequest chat_context = 2;
 * @return {?proto.chatcontext.CreateChatContextRequest}
 */
proto.chat.CreateChatRequest.prototype.getChatContext = function() {
  return /** @type{?proto.chatcontext.CreateChatContextRequest} */ (
    jspb.Message.getWrapperField(this, chatcontext_chatcontext_pb.CreateChatContextRequest, 2));
};


/**
 * @param {?proto.chatcontext.CreateChatContextRequest|undefined} value
 * @return {!proto.chat.CreateChatRequest} returns this
*/
proto.chat.CreateChatRequest.prototype.setChatContext = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.CreateChatRequest} returns this
 */
proto.chat.CreateChatRequest.prototype.clearChatContext = function() {
  return this.setChatContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.CreateChatRequest.prototype.hasChatContext = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool is_private = 3;
 * @return {boolean}
 */
proto.chat.CreateChatRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.CreateChatRequest} returns this
 */
proto.chat.CreateChatRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ReferringContext.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ReferringContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ReferringContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ReferringContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    objectId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ReferringContext}
 */
proto.chat.ReferringContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ReferringContext;
  return proto.chat.ReferringContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ReferringContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ReferringContext}
 */
proto.chat.ReferringContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setObjectType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ReferringContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ReferringContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ReferringContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ReferringContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getObjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.MODEL_TYPE object_type = 1;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.chat.ReferringContext.prototype.getObjectType = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.chat.ReferringContext} returns this
 */
proto.chat.ReferringContext.prototype.setObjectType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string object_id = 2;
 * @return {string}
 */
proto.chat.ReferringContext.prototype.getObjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ReferringContext} returns this
 */
proto.chat.ReferringContext.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.AppCopilotReferringContextMetadata.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.AppCopilotReferringContextMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.AppCopilotReferringContextMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppCopilotReferringContextMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterQuery: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resultIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    resultsCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.AppCopilotReferringContextMetadata}
 */
proto.chat.AppCopilotReferringContextMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.AppCopilotReferringContextMetadata;
  return proto.chat.AppCopilotReferringContextMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.AppCopilotReferringContextMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.AppCopilotReferringContextMetadata}
 */
proto.chat.AppCopilotReferringContextMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addResultIds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResultsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.AppCopilotReferringContextMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.AppCopilotReferringContextMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.AppCopilotReferringContextMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResultIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getResultsCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string filter_query = 1;
 * @return {string}
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.getFilterQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.AppCopilotReferringContextMetadata} returns this
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.setFilterQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string result_ids = 2;
 * @return {!Array<string>}
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.getResultIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.chat.AppCopilotReferringContextMetadata} returns this
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.setResultIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.chat.AppCopilotReferringContextMetadata} returns this
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.addResultIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.AppCopilotReferringContextMetadata} returns this
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.clearResultIdsList = function() {
  return this.setResultIdsList([]);
};


/**
 * optional int32 results_count = 3;
 * @return {number}
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.getResultsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.AppCopilotReferringContextMetadata} returns this
 */
proto.chat.AppCopilotReferringContextMetadata.prototype.setResultsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListAppCopilotChatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListAppCopilotChatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListAppCopilotChatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListAppCopilotChatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    referringContext: (f = msg.getReferringContext()) && proto.chat.ReferringContext.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListAppCopilotChatsRequest}
 */
proto.chat.ListAppCopilotChatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListAppCopilotChatsRequest;
  return proto.chat.ListAppCopilotChatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListAppCopilotChatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListAppCopilotChatsRequest}
 */
proto.chat.ListAppCopilotChatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ReferringContext;
      reader.readMessage(value,proto.chat.ReferringContext.deserializeBinaryFromReader);
      msg.setReferringContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListAppCopilotChatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListAppCopilotChatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListAppCopilotChatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListAppCopilotChatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferringContext();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.chat.ReferringContext.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReferringContext referring_context = 1;
 * @return {?proto.chat.ReferringContext}
 */
proto.chat.ListAppCopilotChatsRequest.prototype.getReferringContext = function() {
  return /** @type{?proto.chat.ReferringContext} */ (
    jspb.Message.getWrapperField(this, proto.chat.ReferringContext, 1));
};


/**
 * @param {?proto.chat.ReferringContext|undefined} value
 * @return {!proto.chat.ListAppCopilotChatsRequest} returns this
*/
proto.chat.ListAppCopilotChatsRequest.prototype.setReferringContext = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.ListAppCopilotChatsRequest} returns this
 */
proto.chat.ListAppCopilotChatsRequest.prototype.clearReferringContext = function() {
  return this.setReferringContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.ListAppCopilotChatsRequest.prototype.hasReferringContext = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.ListAppCopilotChatsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListAppCopilotChatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListAppCopilotChatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListAppCopilotChatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListAppCopilotChatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatsList: jspb.Message.toObjectList(msg.getChatsList(),
    proto.chat.ChatPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListAppCopilotChatsResponse}
 */
proto.chat.ListAppCopilotChatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListAppCopilotChatsResponse;
  return proto.chat.ListAppCopilotChatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListAppCopilotChatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListAppCopilotChatsResponse}
 */
proto.chat.ListAppCopilotChatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatPreview;
      reader.readMessage(value,proto.chat.ChatPreview.deserializeBinaryFromReader);
      msg.addChats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListAppCopilotChatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListAppCopilotChatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListAppCopilotChatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListAppCopilotChatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChatPreview chats = 1;
 * @return {!Array<!proto.chat.ChatPreview>}
 */
proto.chat.ListAppCopilotChatsResponse.prototype.getChatsList = function() {
  return /** @type{!Array<!proto.chat.ChatPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatPreview, 1));
};


/**
 * @param {!Array<!proto.chat.ChatPreview>} value
 * @return {!proto.chat.ListAppCopilotChatsResponse} returns this
*/
proto.chat.ListAppCopilotChatsResponse.prototype.setChatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatPreview}
 */
proto.chat.ListAppCopilotChatsResponse.prototype.addChats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.ListAppCopilotChatsResponse} returns this
 */
proto.chat.ListAppCopilotChatsResponse.prototype.clearChatsList = function() {
  return this.setChatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.CreateAppCopilotChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.CreateAppCopilotChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateAppCopilotChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    referringContext: (f = msg.getReferringContext()) && proto.chat.ReferringContext.toObject(includeInstance, f),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    referringContextMetadata: (f = msg.getReferringContextMetadata()) && proto.chat.AppCopilotReferringContextMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.CreateAppCopilotChatRequest}
 */
proto.chat.CreateAppCopilotChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.CreateAppCopilotChatRequest;
  return proto.chat.CreateAppCopilotChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.CreateAppCopilotChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.CreateAppCopilotChatRequest}
 */
proto.chat.CreateAppCopilotChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ReferringContext;
      reader.readMessage(value,proto.chat.ReferringContext.deserializeBinaryFromReader);
      msg.setReferringContext(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new proto.chat.AppCopilotReferringContextMetadata;
      reader.readMessage(value,proto.chat.AppCopilotReferringContextMetadata.deserializeBinaryFromReader);
      msg.setReferringContextMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.CreateAppCopilotChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.CreateAppCopilotChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateAppCopilotChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferringContext();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.chat.ReferringContext.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReferringContextMetadata();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.chat.AppCopilotReferringContextMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReferringContext referring_context = 1;
 * @return {?proto.chat.ReferringContext}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.getReferringContext = function() {
  return /** @type{?proto.chat.ReferringContext} */ (
    jspb.Message.getWrapperField(this, proto.chat.ReferringContext, 1));
};


/**
 * @param {?proto.chat.ReferringContext|undefined} value
 * @return {!proto.chat.CreateAppCopilotChatRequest} returns this
*/
proto.chat.CreateAppCopilotChatRequest.prototype.setReferringContext = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.CreateAppCopilotChatRequest} returns this
 */
proto.chat.CreateAppCopilotChatRequest.prototype.clearReferringContext = function() {
  return this.setReferringContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.hasReferringContext = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.CreateAppCopilotChatRequest} returns this
 */
proto.chat.CreateAppCopilotChatRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AppCopilotReferringContextMetadata referring_context_metadata = 3;
 * @return {?proto.chat.AppCopilotReferringContextMetadata}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.getReferringContextMetadata = function() {
  return /** @type{?proto.chat.AppCopilotReferringContextMetadata} */ (
    jspb.Message.getWrapperField(this, proto.chat.AppCopilotReferringContextMetadata, 3));
};


/**
 * @param {?proto.chat.AppCopilotReferringContextMetadata|undefined} value
 * @return {!proto.chat.CreateAppCopilotChatRequest} returns this
*/
proto.chat.CreateAppCopilotChatRequest.prototype.setReferringContextMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.CreateAppCopilotChatRequest} returns this
 */
proto.chat.CreateAppCopilotChatRequest.prototype.clearReferringContextMetadata = function() {
  return this.setReferringContextMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.CreateAppCopilotChatRequest.prototype.hasReferringContextMetadata = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.CreateAppCopilotChatResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.CreateAppCopilotChatResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.CreateAppCopilotChatResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateAppCopilotChatResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chat: (f = msg.getChat()) && proto.chat.Chat.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.CreateAppCopilotChatResponse}
 */
proto.chat.CreateAppCopilotChatResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.CreateAppCopilotChatResponse;
  return proto.chat.CreateAppCopilotChatResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.CreateAppCopilotChatResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.CreateAppCopilotChatResponse}
 */
proto.chat.CreateAppCopilotChatResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.Chat;
      reader.readMessage(value,proto.chat.Chat.deserializeBinaryFromReader);
      msg.setChat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.CreateAppCopilotChatResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.CreateAppCopilotChatResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.CreateAppCopilotChatResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.CreateAppCopilotChatResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChat();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.chat.Chat.serializeBinaryToWriter
    );
  }
};


/**
 * optional Chat chat = 1;
 * @return {?proto.chat.Chat}
 */
proto.chat.CreateAppCopilotChatResponse.prototype.getChat = function() {
  return /** @type{?proto.chat.Chat} */ (
    jspb.Message.getWrapperField(this, proto.chat.Chat, 1));
};


/**
 * @param {?proto.chat.Chat|undefined} value
 * @return {!proto.chat.CreateAppCopilotChatResponse} returns this
*/
proto.chat.CreateAppCopilotChatResponse.prototype.setChat = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.CreateAppCopilotChatResponse} returns this
 */
proto.chat.CreateAppCopilotChatResponse.prototype.clearChat = function() {
  return this.setChat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.CreateAppCopilotChatResponse.prototype.hasChat = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetChatRequest}
 */
proto.chat.GetChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetChatRequest;
  return proto.chat.GetChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetChatRequest}
 */
proto.chat.GetChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.GetChatRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetChatRequest} returns this
 */
proto.chat.GetChatRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.DeleteChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.DeleteChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.DeleteChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.DeleteChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.DeleteChatRequest}
 */
proto.chat.DeleteChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.DeleteChatRequest;
  return proto.chat.DeleteChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.DeleteChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.DeleteChatRequest}
 */
proto.chat.DeleteChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.DeleteChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.DeleteChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.DeleteChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.DeleteChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.DeleteChatRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.DeleteChatRequest} returns this
 */
proto.chat.DeleteChatRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.StopChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.StopChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.StopChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.StopChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.StopChatRequest}
 */
proto.chat.StopChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.StopChatRequest;
  return proto.chat.StopChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.StopChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.StopChatRequest}
 */
proto.chat.StopChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.StopChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.StopChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.StopChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.StopChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.StopChatRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.StopChatRequest} returns this
 */
proto.chat.StopChatRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetChatResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetChatResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetChatResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chat: (f = msg.getChat()) && proto.chat.Chat.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetChatResponse}
 */
proto.chat.GetChatResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetChatResponse;
  return proto.chat.GetChatResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetChatResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetChatResponse}
 */
proto.chat.GetChatResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.Chat;
      reader.readMessage(value,proto.chat.Chat.deserializeBinaryFromReader);
      msg.setChat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetChatResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetChatResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetChatResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChat();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.chat.Chat.serializeBinaryToWriter
    );
  }
};


/**
 * optional Chat chat = 1;
 * @return {?proto.chat.Chat}
 */
proto.chat.GetChatResponse.prototype.getChat = function() {
  return /** @type{?proto.chat.Chat} */ (
    jspb.Message.getWrapperField(this, proto.chat.Chat, 1));
};


/**
 * @param {?proto.chat.Chat|undefined} value
 * @return {!proto.chat.GetChatResponse} returns this
*/
proto.chat.GetChatResponse.prototype.setChat = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.GetChatResponse} returns this
 */
proto.chat.GetChatResponse.prototype.clearChat = function() {
  return this.setChat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.GetChatResponse.prototype.hasChat = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.ListChatsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListChatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListChatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListChatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatsList: jspb.Message.toObjectList(msg.getChatsList(),
    proto.chat.ChatPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListChatsResponse}
 */
proto.chat.ListChatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListChatsResponse;
  return proto.chat.ListChatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListChatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListChatsResponse}
 */
proto.chat.ListChatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatPreview;
      reader.readMessage(value,proto.chat.ChatPreview.deserializeBinaryFromReader);
      msg.addChats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListChatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListChatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListChatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChatPreview chats = 1;
 * @return {!Array<!proto.chat.ChatPreview>}
 */
proto.chat.ListChatsResponse.prototype.getChatsList = function() {
  return /** @type{!Array<!proto.chat.ChatPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatPreview, 1));
};


/**
 * @param {!Array<!proto.chat.ChatPreview>} value
 * @return {!proto.chat.ListChatsResponse} returns this
*/
proto.chat.ListChatsResponse.prototype.setChatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatPreview}
 */
proto.chat.ListChatsResponse.prototype.addChats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.ListChatsResponse} returns this
 */
proto.chat.ListChatsResponse.prototype.clearChatsList = function() {
  return this.setChatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.UpdateChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.UpdateChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.UpdateChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.UpdateChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    model: jspb.Message.getFieldWithDefault(msg, 4, ""),
    leadPrompt: jspb.Message.getFieldWithDefault(msg, 5, ""),
    initiatePrompt: jspb.Message.getFieldWithDefault(msg, 6, ""),
    playbookInputs: (f = msg.getPlaybookInputs()) && playbook_playbook_pb.PlaybookInputs.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.UpdateChatRequest}
 */
proto.chat.UpdateChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.UpdateChatRequest;
  return proto.chat.UpdateChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.UpdateChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.UpdateChatRequest}
 */
proto.chat.UpdateChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadPrompt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInitiatePrompt(value);
      break;
    case 7:
      var value = new playbook_playbook_pb.PlaybookInputs;
      reader.readMessage(value,playbook_playbook_pb.PlaybookInputs.deserializeBinaryFromReader);
      msg.setPlaybookInputs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.UpdateChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.UpdateChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.UpdateChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.UpdateChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeadPrompt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInitiatePrompt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPlaybookInputs();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      playbook_playbook_pb.PlaybookInputs.serializeBinaryToWriter
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.UpdateChatRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.chat.UpdateChatRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_private = 3;
 * @return {boolean}
 */
proto.chat.UpdateChatRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.chat.UpdateChatRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string lead_prompt = 5;
 * @return {string}
 */
proto.chat.UpdateChatRequest.prototype.getLeadPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setLeadPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string initiate_prompt = 6;
 * @return {string}
 */
proto.chat.UpdateChatRequest.prototype.getInitiatePrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.setInitiatePrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional playbook.PlaybookInputs playbook_inputs = 7;
 * @return {?proto.playbook.PlaybookInputs}
 */
proto.chat.UpdateChatRequest.prototype.getPlaybookInputs = function() {
  return /** @type{?proto.playbook.PlaybookInputs} */ (
    jspb.Message.getWrapperField(this, playbook_playbook_pb.PlaybookInputs, 7));
};


/**
 * @param {?proto.playbook.PlaybookInputs|undefined} value
 * @return {!proto.chat.UpdateChatRequest} returns this
*/
proto.chat.UpdateChatRequest.prototype.setPlaybookInputs = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.UpdateChatRequest} returns this
 */
proto.chat.UpdateChatRequest.prototype.clearPlaybookInputs = function() {
  return this.setPlaybookInputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.UpdateChatRequest.prototype.hasPlaybookInputs = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.SendChatMessageRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.SendChatMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.SendChatMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.SendChatMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SendChatMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    question: jspb.Message.getFieldWithDefault(msg, 2, ""),
    messageType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fileUploadsList: jspb.Message.toObjectList(msg.getFileUploadsList(),
    common_model_pb.FileUploadBody.toObject, includeInstance),
    playbookInputs: (f = msg.getPlaybookInputs()) && playbook_playbook_pb.PlaybookInputs.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.SendChatMessageRequest}
 */
proto.chat.SendChatMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.SendChatMessageRequest;
  return proto.chat.SendChatMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.SendChatMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.SendChatMessageRequest}
 */
proto.chat.SendChatMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 3:
      var value = /** @type {!proto.tichatapi.ClientMessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 5:
      var value = new common_model_pb.FileUploadBody;
      reader.readMessage(value,common_model_pb.FileUploadBody.deserializeBinaryFromReader);
      msg.addFileUploads(value);
      break;
    case 6:
      var value = new playbook_playbook_pb.PlaybookInputs;
      reader.readMessage(value,playbook_playbook_pb.PlaybookInputs.deserializeBinaryFromReader);
      msg.setPlaybookInputs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.SendChatMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.SendChatMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.SendChatMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SendChatMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFileUploadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      common_model_pb.FileUploadBody.serializeBinaryToWriter
    );
  }
  f = message.getPlaybookInputs();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      playbook_playbook_pb.PlaybookInputs.serializeBinaryToWriter
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.SendChatMessageRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SendChatMessageRequest} returns this
 */
proto.chat.SendChatMessageRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string question = 2;
 * @return {string}
 */
proto.chat.SendChatMessageRequest.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SendChatMessageRequest} returns this
 */
proto.chat.SendChatMessageRequest.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional tichatapi.ClientMessageType message_type = 3;
 * @return {!proto.tichatapi.ClientMessageType}
 */
proto.chat.SendChatMessageRequest.prototype.getMessageType = function() {
  return /** @type {!proto.tichatapi.ClientMessageType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tichatapi.ClientMessageType} value
 * @return {!proto.chat.SendChatMessageRequest} returns this
 */
proto.chat.SendChatMessageRequest.prototype.setMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated common.FileUploadBody file_uploads = 5;
 * @return {!Array<!proto.common.FileUploadBody>}
 */
proto.chat.SendChatMessageRequest.prototype.getFileUploadsList = function() {
  return /** @type{!Array<!proto.common.FileUploadBody>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUploadBody, 5));
};


/**
 * @param {!Array<!proto.common.FileUploadBody>} value
 * @return {!proto.chat.SendChatMessageRequest} returns this
*/
proto.chat.SendChatMessageRequest.prototype.setFileUploadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.common.FileUploadBody=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUploadBody}
 */
proto.chat.SendChatMessageRequest.prototype.addFileUploads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.common.FileUploadBody, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.SendChatMessageRequest} returns this
 */
proto.chat.SendChatMessageRequest.prototype.clearFileUploadsList = function() {
  return this.setFileUploadsList([]);
};


/**
 * optional playbook.PlaybookInputs playbook_inputs = 6;
 * @return {?proto.playbook.PlaybookInputs}
 */
proto.chat.SendChatMessageRequest.prototype.getPlaybookInputs = function() {
  return /** @type{?proto.playbook.PlaybookInputs} */ (
    jspb.Message.getWrapperField(this, playbook_playbook_pb.PlaybookInputs, 6));
};


/**
 * @param {?proto.playbook.PlaybookInputs|undefined} value
 * @return {!proto.chat.SendChatMessageRequest} returns this
*/
proto.chat.SendChatMessageRequest.prototype.setPlaybookInputs = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.SendChatMessageRequest} returns this
 */
proto.chat.SendChatMessageRequest.prototype.clearPlaybookInputs = function() {
  return this.setPlaybookInputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.SendChatMessageRequest.prototype.hasPlaybookInputs = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.SendChatMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.SendChatMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.SendChatMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SendChatMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.SendChatMessageResponse}
 */
proto.chat.SendChatMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.SendChatMessageResponse;
  return proto.chat.SendChatMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.SendChatMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.SendChatMessageResponse}
 */
proto.chat.SendChatMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.SendChatMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.SendChatMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.SendChatMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SendChatMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.chat.SendChatMessageResponse.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SendChatMessageResponse} returns this
 */
proto.chat.SendChatMessageResponse.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.TimelineEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.TimelineEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.TimelineEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.TimelineEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    chatId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    artifactId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    label: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    badge: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.TimelineEvent}
 */
proto.chat.TimelineEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.TimelineEvent;
  return proto.chat.TimelineEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.TimelineEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.TimelineEvent}
 */
proto.chat.TimelineEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setArtifactId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBadge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.TimelineEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.TimelineEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.TimelineEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.TimelineEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBadge();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 created_at = 2;
 * @return {number}
 */
proto.chat.TimelineEvent.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string chat_id = 3;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string artifact_id = 4;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string label = 5;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string badge = 7;
 * @return {string}
 */
proto.chat.TimelineEvent.prototype.getBadge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.TimelineEvent} returns this
 */
proto.chat.TimelineEvent.prototype.setBadge = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListTimelineEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListTimelineEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListTimelineEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListTimelineEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListTimelineEventsRequest}
 */
proto.chat.ListTimelineEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListTimelineEventsRequest;
  return proto.chat.ListTimelineEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListTimelineEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListTimelineEventsRequest}
 */
proto.chat.ListTimelineEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListTimelineEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListTimelineEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListTimelineEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListTimelineEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.ListTimelineEventsRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ListTimelineEventsRequest} returns this
 */
proto.chat.ListTimelineEventsRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.ListTimelineEventsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListTimelineEventsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListTimelineEventsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListTimelineEventsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListTimelineEventsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventsList: jspb.Message.toObjectList(msg.getEventsList(),
    proto.chat.TimelineEvent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListTimelineEventsResponse}
 */
proto.chat.ListTimelineEventsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListTimelineEventsResponse;
  return proto.chat.ListTimelineEventsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListTimelineEventsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListTimelineEventsResponse}
 */
proto.chat.ListTimelineEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.TimelineEvent;
      reader.readMessage(value,proto.chat.TimelineEvent.deserializeBinaryFromReader);
      msg.addEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListTimelineEventsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListTimelineEventsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListTimelineEventsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListTimelineEventsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.TimelineEvent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimelineEvent events = 1;
 * @return {!Array<!proto.chat.TimelineEvent>}
 */
proto.chat.ListTimelineEventsResponse.prototype.getEventsList = function() {
  return /** @type{!Array<!proto.chat.TimelineEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.TimelineEvent, 1));
};


/**
 * @param {!Array<!proto.chat.TimelineEvent>} value
 * @return {!proto.chat.ListTimelineEventsResponse} returns this
*/
proto.chat.ListTimelineEventsResponse.prototype.setEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.TimelineEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.TimelineEvent}
 */
proto.chat.ListTimelineEventsResponse.prototype.addEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.TimelineEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.ListTimelineEventsResponse} returns this
 */
proto.chat.ListTimelineEventsResponse.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetChatMessagesSinceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetChatMessagesSinceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetChatMessagesSinceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatMessagesSinceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    since: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetChatMessagesSinceRequest}
 */
proto.chat.GetChatMessagesSinceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetChatMessagesSinceRequest;
  return proto.chat.GetChatMessagesSinceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetChatMessagesSinceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetChatMessagesSinceRequest}
 */
proto.chat.GetChatMessagesSinceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSince(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetChatMessagesSinceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetChatMessagesSinceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetChatMessagesSinceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatMessagesSinceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSince();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.GetChatMessagesSinceRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetChatMessagesSinceRequest} returns this
 */
proto.chat.GetChatMessagesSinceRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 since = 2;
 * @return {number}
 */
proto.chat.GetChatMessagesSinceRequest.prototype.getSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.GetChatMessagesSinceRequest} returns this
 */
proto.chat.GetChatMessagesSinceRequest.prototype.setSince = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.GetChatMessagesSinceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetChatMessagesSinceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetChatMessagesSinceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatMessagesSinceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.chat.ChatMessage.toObject, includeInstance),
    chatTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
    intermediateStatus: (f = msg.getIntermediateStatus()) && proto.chat.GetIntermediateStatusResponse.toObject(includeInstance, f),
    aiQuestionCredits: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetChatMessagesSinceResponse}
 */
proto.chat.GetChatMessagesSinceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetChatMessagesSinceResponse;
  return proto.chat.GetChatMessagesSinceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetChatMessagesSinceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetChatMessagesSinceResponse}
 */
proto.chat.GetChatMessagesSinceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatMessage;
      reader.readMessage(value,proto.chat.ChatMessage.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatTitle(value);
      break;
    case 3:
      var value = new proto.chat.GetIntermediateStatusResponse;
      reader.readMessage(value,proto.chat.GetIntermediateStatusResponse.deserializeBinaryFromReader);
      msg.setIntermediateStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiQuestionCredits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetChatMessagesSinceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetChatMessagesSinceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetChatMessagesSinceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatMessage.serializeBinaryToWriter
    );
  }
  f = message.getChatTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIntermediateStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.chat.GetIntermediateStatusResponse.serializeBinaryToWriter
    );
  }
  f = message.getAiQuestionCredits();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated ChatMessage messages = 1;
 * @return {!Array<!proto.chat.ChatMessage>}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.chat.ChatMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatMessage, 1));
};


/**
 * @param {!Array<!proto.chat.ChatMessage>} value
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
*/
proto.chat.GetChatMessagesSinceResponse.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatMessage}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
 */
proto.chat.GetChatMessagesSinceResponse.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};


/**
 * optional string chat_title = 2;
 * @return {string}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.getChatTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
 */
proto.chat.GetChatMessagesSinceResponse.prototype.setChatTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional GetIntermediateStatusResponse intermediate_status = 3;
 * @return {?proto.chat.GetIntermediateStatusResponse}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.getIntermediateStatus = function() {
  return /** @type{?proto.chat.GetIntermediateStatusResponse} */ (
    jspb.Message.getWrapperField(this, proto.chat.GetIntermediateStatusResponse, 3));
};


/**
 * @param {?proto.chat.GetIntermediateStatusResponse|undefined} value
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
*/
proto.chat.GetChatMessagesSinceResponse.prototype.setIntermediateStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
 */
proto.chat.GetChatMessagesSinceResponse.prototype.clearIntermediateStatus = function() {
  return this.setIntermediateStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.hasIntermediateStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 ai_question_credits = 4;
 * @return {number}
 */
proto.chat.GetChatMessagesSinceResponse.prototype.getAiQuestionCredits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.GetChatMessagesSinceResponse} returns this
 */
proto.chat.GetChatMessagesSinceResponse.prototype.setAiQuestionCredits = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ReactToAnswerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ReactToAnswerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ReactToAnswerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ReactToAnswerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    answerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reaction: jspb.Message.getFieldWithDefault(msg, 2, 0),
    feedback: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ReactToAnswerRequest}
 */
proto.chat.ReactToAnswerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ReactToAnswerRequest;
  return proto.chat.ReactToAnswerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ReactToAnswerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ReactToAnswerRequest}
 */
proto.chat.ReactToAnswerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    case 2:
      var value = /** @type {!proto.chat.AnswerReactionType} */ (reader.readEnum());
      msg.setReaction(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeedback(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ReactToAnswerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ReactToAnswerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ReactToAnswerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ReactToAnswerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReaction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFeedback();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string answer_id = 1;
 * @return {string}
 */
proto.chat.ReactToAnswerRequest.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ReactToAnswerRequest} returns this
 */
proto.chat.ReactToAnswerRequest.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AnswerReactionType reaction = 2;
 * @return {!proto.chat.AnswerReactionType}
 */
proto.chat.ReactToAnswerRequest.prototype.getReaction = function() {
  return /** @type {!proto.chat.AnswerReactionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.chat.AnswerReactionType} value
 * @return {!proto.chat.ReactToAnswerRequest} returns this
 */
proto.chat.ReactToAnswerRequest.prototype.setReaction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string feedback = 3;
 * @return {string}
 */
proto.chat.ReactToAnswerRequest.prototype.getFeedback = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ReactToAnswerRequest} returns this
 */
proto.chat.ReactToAnswerRequest.prototype.setFeedback = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.DeleteReactionToAnswerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.DeleteReactionToAnswerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.DeleteReactionToAnswerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.DeleteReactionToAnswerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    answerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.DeleteReactionToAnswerRequest}
 */
proto.chat.DeleteReactionToAnswerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.DeleteReactionToAnswerRequest;
  return proto.chat.DeleteReactionToAnswerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.DeleteReactionToAnswerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.DeleteReactionToAnswerRequest}
 */
proto.chat.DeleteReactionToAnswerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.DeleteReactionToAnswerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.DeleteReactionToAnswerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.DeleteReactionToAnswerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.DeleteReactionToAnswerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string answer_id = 1;
 * @return {string}
 */
proto.chat.DeleteReactionToAnswerRequest.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.DeleteReactionToAnswerRequest} returns this
 */
proto.chat.DeleteReactionToAnswerRequest.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetIntermediateStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetIntermediateStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetIntermediateStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetIntermediateStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetIntermediateStatusRequest}
 */
proto.chat.GetIntermediateStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetIntermediateStatusRequest;
  return proto.chat.GetIntermediateStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetIntermediateStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetIntermediateStatusRequest}
 */
proto.chat.GetIntermediateStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetIntermediateStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetIntermediateStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetIntermediateStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetIntermediateStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.GetIntermediateStatusRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetIntermediateStatusRequest} returns this
 */
proto.chat.GetIntermediateStatusRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.GetIntermediateStatusResponse.repeatedFields_ = [4];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.chat.GetIntermediateStatusResponse.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.chat.GetIntermediateStatusResponse.ProgressCase = {
  PROGRESS_NOT_SET: 0,
  BUSY: 2,
  PERCENT: 3
};

/**
 * @return {proto.chat.GetIntermediateStatusResponse.ProgressCase}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getProgressCase = function() {
  return /** @type {proto.chat.GetIntermediateStatusResponse.ProgressCase} */(jspb.Message.computeOneofCase(this, proto.chat.GetIntermediateStatusResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetIntermediateStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetIntermediateStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetIntermediateStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetIntermediateStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    busy: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    percent: (f = msg.getPercent()) && tichatapi_agent_pb.Progress.toObject(includeInstance, f),
    artifactsList: jspb.Message.toObjectList(msg.getArtifactsList(),
    artifact_artifact_pb.Artifact.toObject, includeInstance),
    cancelledTime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    progressCancellable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    busyUntilMs: jspb.Message.getFieldWithDefault(msg, 7, 0),
    awaitingInput: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetIntermediateStatusResponse}
 */
proto.chat.GetIntermediateStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetIntermediateStatusResponse;
  return proto.chat.GetIntermediateStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetIntermediateStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetIntermediateStatusResponse}
 */
proto.chat.GetIntermediateStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusy(value);
      break;
    case 3:
      var value = new tichatapi_agent_pb.Progress;
      reader.readMessage(value,tichatapi_agent_pb.Progress.deserializeBinaryFromReader);
      msg.setPercent(value);
      break;
    case 4:
      var value = new artifact_artifact_pb.Artifact;
      reader.readMessage(value,artifact_artifact_pb.Artifact.deserializeBinaryFromReader);
      msg.addArtifacts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancelledTime(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProgressCancellable(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBusyUntilMs(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAwaitingInput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetIntermediateStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetIntermediateStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetIntermediateStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetIntermediateStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPercent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      tichatapi_agent_pb.Progress.serializeBinaryToWriter
    );
  }
  f = message.getArtifactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      artifact_artifact_pb.Artifact.serializeBinaryToWriter
    );
  }
  f = message.getCancelledTime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getProgressCancellable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getBusyUntilMs();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAwaitingInput();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool busy = 2;
 * @return {boolean}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getBusy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setBusy = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.chat.GetIntermediateStatusResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.clearBusy = function() {
  return jspb.Message.setOneofField(this, 2, proto.chat.GetIntermediateStatusResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.GetIntermediateStatusResponse.prototype.hasBusy = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional tichatapi.Progress percent = 3;
 * @return {?proto.tichatapi.Progress}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getPercent = function() {
  return /** @type{?proto.tichatapi.Progress} */ (
    jspb.Message.getWrapperField(this, tichatapi_agent_pb.Progress, 3));
};


/**
 * @param {?proto.tichatapi.Progress|undefined} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
*/
proto.chat.GetIntermediateStatusResponse.prototype.setPercent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.chat.GetIntermediateStatusResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.clearPercent = function() {
  return this.setPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.chat.GetIntermediateStatusResponse.prototype.hasPercent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated artifact.Artifact artifacts = 4;
 * @return {!Array<!proto.artifact.Artifact>}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getArtifactsList = function() {
  return /** @type{!Array<!proto.artifact.Artifact>} */ (
    jspb.Message.getRepeatedWrapperField(this, artifact_artifact_pb.Artifact, 4));
};


/**
 * @param {!Array<!proto.artifact.Artifact>} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
*/
proto.chat.GetIntermediateStatusResponse.prototype.setArtifactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.artifact.Artifact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Artifact}
 */
proto.chat.GetIntermediateStatusResponse.prototype.addArtifacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.artifact.Artifact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.clearArtifactsList = function() {
  return this.setArtifactsList([]);
};


/**
 * optional int64 cancelled_time = 5;
 * @return {number}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getCancelledTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setCancelledTime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool progress_cancellable = 6;
 * @return {boolean}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getProgressCancellable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setProgressCancellable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 busy_until_ms = 7;
 * @return {number}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getBusyUntilMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setBusyUntilMs = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool awaiting_input = 8;
 * @return {boolean}
 */
proto.chat.GetIntermediateStatusResponse.prototype.getAwaitingInput = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.chat.GetIntermediateStatusResponse} returns this
 */
proto.chat.GetIntermediateStatusResponse.prototype.setAwaitingInput = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetStreamingMessagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetStreamingMessagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetStreamingMessagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetStreamingMessagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messagesSince: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetStreamingMessagesRequest}
 */
proto.chat.GetStreamingMessagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetStreamingMessagesRequest;
  return proto.chat.GetStreamingMessagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetStreamingMessagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetStreamingMessagesRequest}
 */
proto.chat.GetStreamingMessagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMessagesSince(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetStreamingMessagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetStreamingMessagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetStreamingMessagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetStreamingMessagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessagesSince();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.GetStreamingMessagesRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.GetStreamingMessagesRequest} returns this
 */
proto.chat.GetStreamingMessagesRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 messages_since = 2;
 * @return {number}
 */
proto.chat.GetStreamingMessagesRequest.prototype.getMessagesSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.GetStreamingMessagesRequest} returns this
 */
proto.chat.GetStreamingMessagesRequest.prototype.setMessagesSince = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.GetStreamingMessagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.GetStreamingMessagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.GetStreamingMessagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.GetStreamingMessagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetStreamingMessagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.chat.ChatMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.GetStreamingMessagesResponse}
 */
proto.chat.GetStreamingMessagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.GetStreamingMessagesResponse;
  return proto.chat.GetStreamingMessagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.GetStreamingMessagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.GetStreamingMessagesResponse}
 */
proto.chat.GetStreamingMessagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatMessage;
      reader.readMessage(value,proto.chat.ChatMessage.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.GetStreamingMessagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.GetStreamingMessagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.GetStreamingMessagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.GetStreamingMessagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatMessage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChatMessage messages = 1;
 * @return {!Array<!proto.chat.ChatMessage>}
 */
proto.chat.GetStreamingMessagesResponse.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.chat.ChatMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatMessage, 1));
};


/**
 * @param {!Array<!proto.chat.ChatMessage>} value
 * @return {!proto.chat.GetStreamingMessagesResponse} returns this
*/
proto.chat.GetStreamingMessagesResponse.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatMessage}
 */
proto.chat.GetStreamingMessagesResponse.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.GetStreamingMessagesResponse} returns this
 */
proto.chat.GetStreamingMessagesResponse.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.SearchChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.SearchChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.SearchChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.SearchChatRequest}
 */
proto.chat.SearchChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.SearchChatRequest;
  return proto.chat.SearchChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.SearchChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.SearchChatRequest}
 */
proto.chat.SearchChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.SearchChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.SearchChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.SearchChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.chat.SearchChatRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SearchChatRequest} returns this
 */
proto.chat.SearchChatRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.SearchChatResult.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.SearchChatResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.SearchChatResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dataId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    snippetHtml: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.SearchChatResult}
 */
proto.chat.SearchChatResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.SearchChatResult;
  return proto.chat.SearchChatResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.SearchChatResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.SearchChatResult}
 */
proto.chat.SearchChatResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatName(value);
      break;
    case 3:
      var value = /** @type {!proto.chat.ChatSearchResultType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnippetHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.SearchChatResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.SearchChatResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.SearchChatResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDataId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSnippetHtml();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.SearchChatResult.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chat_name = 2;
 * @return {string}
 */
proto.chat.SearchChatResult.prototype.getChatName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setChatName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ChatSearchResultType type = 3;
 * @return {!proto.chat.ChatSearchResultType}
 */
proto.chat.SearchChatResult.prototype.getType = function() {
  return /** @type {!proto.chat.ChatSearchResultType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.chat.ChatSearchResultType} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string data_id = 4;
 * @return {string}
 */
proto.chat.SearchChatResult.prototype.getDataId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setDataId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.chat.SearchChatResult.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string snippet_html = 6;
 * @return {string}
 */
proto.chat.SearchChatResult.prototype.getSnippetHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.SearchChatResult} returns this
 */
proto.chat.SearchChatResult.prototype.setSnippetHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.SearchChatResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.SearchChatResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.SearchChatResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.SearchChatResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.chat.SearchChatResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.SearchChatResponse}
 */
proto.chat.SearchChatResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.SearchChatResponse;
  return proto.chat.SearchChatResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.SearchChatResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.SearchChatResponse}
 */
proto.chat.SearchChatResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.SearchChatResult;
      reader.readMessage(value,proto.chat.SearchChatResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.SearchChatResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.SearchChatResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.SearchChatResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.SearchChatResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.SearchChatResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SearchChatResult results = 1;
 * @return {!Array<!proto.chat.SearchChatResult>}
 */
proto.chat.SearchChatResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.chat.SearchChatResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.SearchChatResult, 1));
};


/**
 * @param {!Array<!proto.chat.SearchChatResult>} value
 * @return {!proto.chat.SearchChatResponse} returns this
*/
proto.chat.SearchChatResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.SearchChatResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.SearchChatResult}
 */
proto.chat.SearchChatResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.SearchChatResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.SearchChatResponse} returns this
 */
proto.chat.SearchChatResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListChatsForPlaybookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListChatsForPlaybookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListChatsForPlaybookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsForPlaybookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListChatsForPlaybookRequest}
 */
proto.chat.ListChatsForPlaybookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListChatsForPlaybookRequest;
  return proto.chat.ListChatsForPlaybookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListChatsForPlaybookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListChatsForPlaybookRequest}
 */
proto.chat.ListChatsForPlaybookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListChatsForPlaybookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListChatsForPlaybookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListChatsForPlaybookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsForPlaybookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.chat.ListChatsForPlaybookRequest.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ListChatsForPlaybookRequest} returns this
 */
proto.chat.ListChatsForPlaybookRequest.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.PlaybookRunInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.PlaybookRunInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.PlaybookRunInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.PlaybookRunInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    paramsJson: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.PlaybookRunInfo}
 */
proto.chat.PlaybookRunInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.PlaybookRunInfo;
  return proto.chat.PlaybookRunInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.PlaybookRunInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.PlaybookRunInfo}
 */
proto.chat.PlaybookRunInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParamsJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.PlaybookRunInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.PlaybookRunInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.PlaybookRunInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.PlaybookRunInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getParamsJson();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.chat.PlaybookRunInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.PlaybookRunInfo} returns this
 */
proto.chat.PlaybookRunInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 created_at = 2;
 * @return {number}
 */
proto.chat.PlaybookRunInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.PlaybookRunInfo} returns this
 */
proto.chat.PlaybookRunInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string params_json = 3;
 * @return {string}
 */
proto.chat.PlaybookRunInfo.prototype.getParamsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.PlaybookRunInfo} returns this
 */
proto.chat.PlaybookRunInfo.prototype.setParamsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.ChatWithPlaybookRuns.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ChatWithPlaybookRuns.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ChatWithPlaybookRuns.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ChatWithPlaybookRuns} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatWithPlaybookRuns.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdByUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdByUserName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdByUserEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
    chatCreatedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    playbookRunsList: jspb.Message.toObjectList(msg.getPlaybookRunsList(),
    proto.chat.PlaybookRunInfo.toObject, includeInstance),
    chatUpdatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ChatWithPlaybookRuns}
 */
proto.chat.ChatWithPlaybookRuns.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ChatWithPlaybookRuns;
  return proto.chat.ChatWithPlaybookRuns.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ChatWithPlaybookRuns} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ChatWithPlaybookRuns}
 */
proto.chat.ChatWithPlaybookRuns.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserEmail(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChatCreatedAt(value);
      break;
    case 7:
      var value = new proto.chat.PlaybookRunInfo;
      reader.readMessage(value,proto.chat.PlaybookRunInfo.deserializeBinaryFromReader);
      msg.addPlaybookRuns(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChatUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ChatWithPlaybookRuns.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ChatWithPlaybookRuns.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ChatWithPlaybookRuns} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ChatWithPlaybookRuns.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedByUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedByUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedByUserEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChatCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPlaybookRunsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.chat.PlaybookRunInfo.serializeBinaryToWriter
    );
  }
  f = message.getChatUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chat_name = 2;
 * @return {string}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getChatName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setChatName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string created_by_user_id = 3;
 * @return {string}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getCreatedByUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string created_by_user_name = 4;
 * @return {string}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getCreatedByUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setCreatedByUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_by_user_email = 5;
 * @return {string}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getCreatedByUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setCreatedByUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 chat_created_at = 6;
 * @return {number}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getChatCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setChatCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated PlaybookRunInfo playbook_runs = 7;
 * @return {!Array<!proto.chat.PlaybookRunInfo>}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getPlaybookRunsList = function() {
  return /** @type{!Array<!proto.chat.PlaybookRunInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.PlaybookRunInfo, 7));
};


/**
 * @param {!Array<!proto.chat.PlaybookRunInfo>} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
*/
proto.chat.ChatWithPlaybookRuns.prototype.setPlaybookRunsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.chat.PlaybookRunInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.PlaybookRunInfo}
 */
proto.chat.ChatWithPlaybookRuns.prototype.addPlaybookRuns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.chat.PlaybookRunInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.clearPlaybookRunsList = function() {
  return this.setPlaybookRunsList([]);
};


/**
 * optional int64 chat_updated_at = 8;
 * @return {number}
 */
proto.chat.ChatWithPlaybookRuns.prototype.getChatUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.chat.ChatWithPlaybookRuns} returns this
 */
proto.chat.ChatWithPlaybookRuns.prototype.setChatUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.chat.ListChatsForPlaybookResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.chat.ListChatsForPlaybookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.chat.ListChatsForPlaybookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.chat.ListChatsForPlaybookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsForPlaybookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatsList: jspb.Message.toObjectList(msg.getChatsList(),
    proto.chat.ChatWithPlaybookRuns.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.chat.ListChatsForPlaybookResponse}
 */
proto.chat.ListChatsForPlaybookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.chat.ListChatsForPlaybookResponse;
  return proto.chat.ListChatsForPlaybookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.chat.ListChatsForPlaybookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.chat.ListChatsForPlaybookResponse}
 */
proto.chat.ListChatsForPlaybookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.chat.ChatWithPlaybookRuns;
      reader.readMessage(value,proto.chat.ChatWithPlaybookRuns.deserializeBinaryFromReader);
      msg.addChats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.chat.ListChatsForPlaybookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.chat.ListChatsForPlaybookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.chat.ListChatsForPlaybookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.chat.ListChatsForPlaybookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.chat.ChatWithPlaybookRuns.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChatWithPlaybookRuns chats = 1;
 * @return {!Array<!proto.chat.ChatWithPlaybookRuns>}
 */
proto.chat.ListChatsForPlaybookResponse.prototype.getChatsList = function() {
  return /** @type{!Array<!proto.chat.ChatWithPlaybookRuns>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.chat.ChatWithPlaybookRuns, 1));
};


/**
 * @param {!Array<!proto.chat.ChatWithPlaybookRuns>} value
 * @return {!proto.chat.ListChatsForPlaybookResponse} returns this
*/
proto.chat.ListChatsForPlaybookResponse.prototype.setChatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.chat.ChatWithPlaybookRuns=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chat.ChatWithPlaybookRuns}
 */
proto.chat.ListChatsForPlaybookResponse.prototype.addChats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.chat.ChatWithPlaybookRuns, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.chat.ListChatsForPlaybookResponse} returns this
 */
proto.chat.ListChatsForPlaybookResponse.prototype.clearChatsList = function() {
  return this.setChatsList([]);
};


/**
 * @enum {number}
 */
proto.chat.AnswerReactionType = {
  LIKE: 0,
  DISLIKE: 1
};

/**
 * @enum {number}
 */
proto.chat.ChatMessageType = {
  AGENT: 0,
  USER: 1
};

/**
 * @enum {number}
 */
proto.chat.ChatSearchResultType = {
  CHAT: 0,
  QUESTION: 1,
  ANSWER: 2
};

/**
 * @enum {number}
 */
proto.chat.StreamingMessageType = {
  STREAMING_MESSAGE_TYPE_NONE: 0,
  STREAMING_MESSAGE_TYPE_INTERIM: 1,
  STREAMING_MESSAGE_TYPE_DEBUG: 2,
  STREAMING_MESSAGE_TYPE_PLAN: 3
};

goog.object.extend(exports, proto.chat);
